import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Branch, BranchResponse, CreateBranchRequest, UpdateBranchRequest } from '@models/file-management/branch/branch.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class BranchesService {
  private readonly url = `${environment.bffUrl}/file-management/branches`;
  constructor(private httpClient: HttpClient) {}

  getAll(): Observable<Branch[]> {
    return this.httpClient.get<BranchResponse[]>(this.url);
  }

  getOne(id: string): Observable<Branch> {
    return this.httpClient.get<BranchResponse>(`${this.url}/${id}`);
  }

  add(branch: CreateBranchRequest): Observable<Branch> {
    return this.httpClient.post<BranchResponse>(this.url, branch);
  }

  update(id: string, branch: UpdateBranchRequest): Observable<Branch> {
    return this.httpClient.put<BranchResponse>(`${this.url}/${id}`, branch);
  }

  delete(id: string): Observable<void> {
    return this.httpClient.delete<void>(`${this.url}/${id}`);
  }
}
